import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-2 p-4 rounded-md flex flex-col md:flex-row md:items-center justify-between gap-6 mx-1 mb-4" }
const _hoisted_2 = { class: "flex flex-col md:flex-row gap-6" }
const _hoisted_3 = { class: "w-44 flex flex-row items-center gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Envio"), -1)
const _hoisted_5 = { class: "px-3 py-2 rounded-md bg-h-primary-100 text-h-primary-500" }
const _hoisted_6 = { class: "w-48 flex flex-row items-center gap-2 md:mr-12 sm:mr-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, /*#__PURE__*/_toDisplayString("Corrigidos"), -1)
const _hoisted_8 = { class: "px-3 py-2 rounded-md bg-h-success-100 text-h-success-500 w-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_v_icon, {
          name: "fa-chevron-circle-right",
          class: "text-h-primary-500"
        }),
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.sents), 1)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_v_icon, {
          name: "fa-check-circle",
          class: "text-h-success-500"
        }),
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.correcteds), 1)
      ]),
      _createVNode(_component_Button, {
        class: "btn-outline",
        label: 
          _ctx.$t('labels.generic', { en: 'See Activity', pt: 'Ver Atividade' })
        ,
        onClick: _withModifiers(_ctx.goTo, ["prevent"])
      }, null, 8, ["label", "onClick"])
    ])
  ]))
}